import { isSpSize } from "../../common/utils/isSpSize";

class MarkerModel {
  // ---------------------------------------------------------------------------
  // --	MarkerModel
  // ---------------------------------------------------------------------------

  constructor(marker) {
    this.marker = marker;
    this.model = JSON.parse(marker.dataset.model);
  }

  get scale() {
    return this.model.scale;
  }

  get alpha() {
    return this.model.alpha;
  }

  get offsetY() {
    return this.marker.getBoundingClientRect().y;
  }

  getAnchorY() {
    //ヘッダーとウィンドウの高さ
    const headerH = isSpSize()
      ? 0
      : document.querySelector("#global_header").clientHeight;
    const windowH = window.innerHeight;

    return (
      window.scrollY +
      Math.ceil(this.marker.getBoundingClientRect().y) -
      headerH -
      (windowH - headerH) * this.model.anchor
    );
  }

  // ---------------------------------------------------------------------------
}

export default MarkerModel;
